
import * as React from 'react';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import { LandingErrorComponentProps } from './landingpageerrorcomponent';
import { LandingPageErrorCSSStyle } from './landingpageerrorcss';

export class LandingPageErrorViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
      this.onLoginClick = this.onLoginClick.bind(this);
    }

    draw(props: LandingErrorComponentProps, state: UIComponentState, cssStyle: LandingPageErrorCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={{display: "inline-block", width: "100%", height: "100%", textAlign: 'center'}}>
              <label style={{height: "40px", width: "100%", color: "#000000"}}>{"Oops Something went wrong, Please"}
              <u style={{cursor: "pointer"}} onClick={this.onLoginClick}>{" click here "}</u>
              {"to continue"}
              </label>
            </div>);
    }


    onLoginClick()
    {
      window.location.reload(false);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/landingpage/error/landingpageerrorview.tsx